import BrowserLocalStorage from '../../../utils/browserLocalStorage';

export default class RecipeLocalStorage extends BrowserLocalStorage {
	constructor(key) {
		super(key);
	}

	setUserEntry(recipeId, rate) {
		this.setValueAsArray({ recipeId, rate });
	}

	getRating(recipeId) {
		return this.getValueByKey(recipeId, JSON.parse(this.getValue()));
	}

	addToRatingList(recipeId, rate) {
		this.appendToExisitingValues({ recipeId, rate });
	}

	getValueByKey(id, jsonParsedArray) {
		for (const key in jsonParsedArray) {
			if (jsonParsedArray[key].recipeId == id) {
				return jsonParsedArray[key].rate;
			}
		}
		return null;
	}
}
